import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { authenticate, registerPushToken } from 'config/api';

import * as env from 'config/environment';
import { registerDataLayer } from 'hooks/useUserAssetInfo';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { isApp } from 'components/features/utils/userStatus';
import { HeadBlock } from './components/HeadBlock';

const Auth: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { setBack } = useCustomizeHeaderContext();

  const fromLpToNoticeURL = 'notificationList/2/1/1';

  useEffect(() => {
    (async (): Promise<void> => {
      const checkRet = await fetch(
        `${env.appURL}/authcheck?t=${new Date().getTime()}`,
        {
          method: 'GET',
        }
      );
      if (checkRet?.status !== 200) {
        window.location.href = env.appURL;
        return;
      }

      const authRet = await authenticate();
      if (!authRet?.Authenticated) {
        window.location.href = env.appURL;
        return;
      }

      sessionStorage.setItem('user', JSON.stringify(authRet.User));

      registerDataLayer();

      if (isApp) {
        const ret = await window.flutter_inappwebview.callHandler(
          'keyFlutterRequestDeviceToken'
        );
        if (ret) await registerPushToken(ret.token);
      }

      const isFromLpToNotice = (url: string): boolean =>
        url === fromLpToNoticeURL;
      const callbackPathStr = 'callbackPath';

      const qParams = new URLSearchParams(location.search);
      const callbackPath = ((setBackTo: (url: string) => void): string => {
        if (!(qParams && qParams.has(callbackPathStr))) return '/home';
        const searchedCallbackPath = qParams.get(callbackPathStr);
        if (searchedCallbackPath === null) return '/home';

        if (isFromLpToNotice(searchedCallbackPath)) {
          setBackTo('/home');
        }
        return searchedCallbackPath;
      })((url: string) => {
        setBack({ to: url });
      });
      history.push(callbackPath);
    })();
  }, [history, location.search, setBack]);

  return (
    <>
      <HeadBlock />
      <div className="w-full h-full flex items-center justify-center">
        <img
          alt="みんかぶアセットプランナー"
          src="./static/images/minkabu_assetplanner.svg"
          width="130px"
          className="animation-reverse animation-infinite animation-y-rotate"
        />
      </div>
    </>
  );
};

export default Auth;
